export const SET_CV = "SET_CV";
export const ADD_DATA = "ADD_DATA";
export const SET_DATA = "SET_DATA";
export const GET_DATA = "GET_DATA";
export const ADD_EDU = "ADD_EDU";
export const ADD_EXP = "ADD_EXP";
export const SET_CURRENT = "SET_CURRENT";
export const DELETE_EDU = "DELETE_EDU";
export const DELETE_EXP = "DELETE_EXP";
